var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHitLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128.073,
    height: 60,
    viewBox: "0 0 128.073 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_91",
    x: 13.764,
    y: 25.427,
    width: 22.765,
    height: 24.865,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_92",
    x: 0,
    y: 0,
    width: 50.292,
    height: 46.713,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_93",
    x: 38.896,
    y: 0,
    width: 50.292,
    height: 49.958,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_94",
    x: 77.781,
    y: 0,
    width: 50.292,
    height: 50.097,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(-895.964 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 895.96, 9)",
    filter: "url(#Path_91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91-2",
    "data-name": "Path 91",
    d: "M2291.765,3716.325a18.06,18.06,0,0,1-8.765,0V3706h8.765Z",
    transform: "translate(-2262.24 -3675.57)",
    fill: "red",
    stroke: "#fefefe",
    strokeWidth: 2,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 895.96, 9)",
    filter: "url(#Path_92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92-2",
    "data-name": "Path 92",
    d: "M1128.14,1539a18.125,18.125,0,0,1,12.355,31.41v-21.519h-7.967v8.894h-8.765v-8.894h-7.979v21.519A18.132,18.132,0,0,1,1128.14,1539Z",
    transform: "translate(-1103 -1534)",
    fill: "red",
    stroke: "#fefefe",
    strokeWidth: 2,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 895.96, 9)",
    filter: "url(#Path_93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93-2",
    "data-name": "Path 93",
    d: "M4443.14,1539a18.142,18.142,0,0,1,4.776,35.646v-25.755h-9.551v25.755A18.144,18.144,0,0,1,4443.14,1539Z",
    transform: "translate(-4379.1 -1534)",
    fill: "#fd0",
    stroke: "#fefefe",
    strokeWidth: 2,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 895.96, 9)",
    filter: "url(#Path_94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94-2",
    "data-name": "Path 94",
    d: "M7757.151,1539a18.145,18.145,0,0,1,3.99,35.846v-19.583h8.1v-6.641h-24.183v6.641h8.107v19.583a18.144,18.144,0,0,1,3.989-35.846Z",
    transform: "translate(-7654.22 -1534)",
    fill: "blue",
    stroke: "#fefefe",
    strokeWidth: 2,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1142.675,4930.581l-2.089,5.492h4.177Zm-1.8-2.581h3.579l5.4,12.9h-3.227l-1.033-2.652h-5.82l-.986,2.652h-3.25Zm-16.392,8.084h2.992v.528a2.3,2.3,0,0,0-.023.27v.246a2.882,2.882,0,0,0,.305,1.338c.2.387.692.586,1.467.586.81,0,1.3-.2,1.49-.586a3.2,3.2,0,0,0,.293-1.467v-9h3.086v9.117a8.38,8.38,0,0,1-.2,1.819,2.523,2.523,0,0,1-1.115,1.5,4.363,4.363,0,0,1-1.373.575,6.851,6.851,0,0,1-1.549.211,1.277,1.277,0,0,1-.211.012h-.657l-.446-.035h-.188l-.176-.036a6.135,6.135,0,0,1-2.241-.727,2.6,2.6,0,0,1-1.326-1.689,5.385,5.385,0,0,1-.117-.74c-.023-.246-.023-.5-.023-.75v-.293a2.254,2.254,0,0,1,.012-.281v-.6Zm-5.257,4.811V4928h3.086v12.9Zm-13.822,0v-2.241l8.167-8.319h-8V4928h11.757v2.241l-8.19,8.319h8v2.335Zm-5.139,0V4928h3.086v12.9Zm-9.621,0-5.163-12.9h3.4l3.191,9.656,3.262-9.656h3.379l-5.116,12.9Zm-17.166,0V4928h10.9v2.241h-7.85v2.746h7.181v2.206h-7.181v3.32h8.225v2.382Zm-12.109,0V4928h3.086v10.513h7.333v2.382Zm-13.634,0V4928h10.9v2.241h-7.85v2.746h7.181v2.206h-7.181v3.32h8.225v2.382Zm-9.293,0v-10.6H1034V4928h11.968v2.3h-4.435v10.6Z",
    transform: "translate(-131.928 -4872.235)",
    fill: "#222631",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitLogo);
export default __webpack_public_path__ + "static/media/hit-logo.3f6974cdaf5dda2bce169a5aac66357c.svg";
export { ForwardRef as ReactComponent };